import { Box, Heading } from '@chakra-ui/react';
import React from 'react'
import { Doughnut } from 'react-chartjs-2';

export default function TotalTransactionsChart({ reportData }) {

  const calculateCategoryCounts = (data) => {
    const categoryCounts = {};
    data?.forEach((item) => {
      const category = item.Category;
      if (categoryCounts[category]) {
        categoryCounts[category]++;
      } else {
        categoryCounts[category] = 1;
      }
    });
    return categoryCounts;
  };

  const categoryCounts = calculateCategoryCounts(reportData?.Transactions);
  const transactionCount = reportData?.Transactions?.length;
  const labels = Object.keys(categoryCounts);
  const values = Object.values(categoryCounts);

  const chartData = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: [
          "rgb(135, 91, 247)",
          "rgb(22, 179, 100)",
          "rgb(247, 144, 9)",
          "rgb(240, 68, 56)",
          "rgb(255, 87, 51)",
          "rgb(51, 255, 206)",
          "rgb(51, 91, 255)",
          "rgb(255, 51, 168)",
        ],
        hoverBackgroundColor: [
          "rgb(135, 91, 247)",
          "rgb(22, 179, 100)",
          "rgb(247, 144, 9)",
          "rgb(240, 68, 56)",
          "rgb(255, 87, 51)",
          "rgb(51, 255, 206)",
          "rgb(51, 91, 255)",
          "rgb(255, 51, 168)",
        ],
      },
    ],
  };

  const options = {
    layout: {
      padding: {
        right: 15
      }
    },
    legend: {
      display: true,
      onClick: function (e, legendItem) {
        e.preventDefault();
        e.stopPropagation();
      },
      position: 'bottom',
      labels: {
        fontFamily: "Poppins",
        fontColor: '#000',
        fontSize: 12,
        fontStyle: 'normal',
        usePointStyle: true,
        padding: 20,
      },
    },
    maintainAspectRatio: true,
    cutoutPercentage: 70,
    tooltips: {
      position: 'nearest',
      backgroundColor: 'rgba(255,255,255,1)',
      titleFontColor: '#000',
      bodyFontColor: '#000',
      titleFontSize: 14,
      titleFontFamily: "Poppins",
      bodyFontFamily: "Poppins",
      bodyFontSize: 14,
      bodySpacing: 4,
      xPadding: 12,
      yPadding: 12,
      borderColor: '#D3D2D5',
      borderWidth: 1,
      displayColors: false,
      callbacks: {
        title: function (tooltipItem, data) {
          return data.labels[tooltipItem[0].index];
        },
        label: function (tooltipItem, data) {
          const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
          return `${'Total: ' + value}`;
        }
      }
    },
    elements: {
      arc: {
        borderWidth: 2,
      },
    },
  };

  return (
    <Box className='investor_chart'>
      <Heading as="h2" className='font-poppins card_heading'>Total Transactions: {transactionCount}</Heading>
      <Box mt={6}>
        <Doughnut height={220} data={chartData} options={options} />
      </Box>
    </Box>
  )
}
